import Installation from './01.installation';
import Domain from './02.domain';

const Y7 = [
    Installation,
    ...Domain
];

export default Y7;